import ServerPageInterface from 'src/shared/types/server-page-interface'
import fixIsMasterBlockRootCommandForClient from './fixIsMasterBlockRootCommandForClient'

// NOTE: for fixing https://app.shortcut.com/systeme/story/51271/adding-masterblock-creates-duplicates-on-page-header-and-footer
export default function fixIsMasterBlockRootCommand(
  page: ServerPageInterface,
): [ServerPageInterface, boolean] {
  const originalEntities = page.content.entities
  const [entities, needChangeContent] =
    fixIsMasterBlockRootCommandForClient(originalEntities)

  return [
    {
      ...page,
      content: {
        ...page.content,
        entities,
      },
    },
    needChangeContent,
  ]
}
